import Vue from "vue";
import { loadingItms,skeleton,text_ellipsis } from "./directives.js";
import Ripple from 'vue-ripple-directive'
Ripple.color = 'rgba(247, 247, 247, 0.35)';

Vue.directive('ripple', Ripple);//点击涟漪效果
Vue.directive("loadingItms", loadingItms);
// Vue.directive("skeleton", skeleton);
Vue.directive('skeleton', skeleton);
Vue.directive("text-ellipsis", text_ellipsis);